import { createFirebaseApp } from "@mattfinkel/common-web";

/**
 * This app's Firebase handles.
 *
 * The factory lives in the shared package; only this four-line call site can
 * live here, because `import.meta.env` is substituted at THIS app's build by
 * THIS app's Vite, which never transforms anything under node_modules.
 *
 * **Keep the STATIC dot access.** `import.meta.env.VITE_FIREBASE_API_KEY`,
 * never `import.meta.env[name]` with a computed key. Vite can only substitute
 * a reference it resolves statically; given a computed one it gives up and
 * inlines the WHOLE env object, so every VITE_* var present at build time
 * lands in the bundle whether any code reads it or not.
 *
 * No `db` export, deliberately. Importing `firebase/firestore` at module scope
 * pulls the entire Firestore SDK into the bundle whether it is called or not
 * -- measured at 55% of the download on a sibling app, on every first paint,
 * for a module it never touched. An app that reads Firestore calls
 * `getFirestore(firebaseApp)` itself, in the same change that puts real rules
 * in `firestore.rules`.
 */
export const { firebaseApp, auth, googleProvider } = createFirebaseApp({
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
});
